/**
 * Every string the login screen shows, in one place.
 */
export const COPY = {
  // Sign-in card
  brand: 'Dalabtire',
  signIn: 'Sign in',
  signInSub: 'Cashiers, managers and accountants.',
  username: 'Username',
  password: 'Password',
  usernamePlaceholder: 'Your username',
  passwordPlaceholder: 'Your password',
  connected: 'Connected',
  offline: 'No internet connection',

  // Support
  needHelp: 'Need help?',
  whatsappHint: (display) => `Open a WhatsApp chat with ${display}`,

  // Waiter rail
  waiters: 'Waiters',
  waitersSub: 'Tap your name, then enter your PIN.',
  addWaiter: 'Add waiter',
  manage: 'Manage',
  done: 'Done',
  noWaitersTitle: 'No waiters on this till yet.',
  noWaitersBody: 'Add one to give them a tile.',
  storageNote:
    'These tiles are saved on this computer only. Passwords are never stored — only the name and username.',

  // Add waiter
  addTitle: 'Add a waiter',
  addSub: 'Their username and password, once.',
  addNote:
    'Their name and username are saved. The password is used for this one check and never written to disk.',
  cancel: 'Cancel',
  checkAndAdd: 'Check & add',
  checking: 'Checking…',
  addAnother: 'Add another',
  addedTitle: (name) => `${name} added`,
  addedBody:
    'Their tile is now on this till. Next time they just tap their name and their PIN.',

  // PIN pad
  enterPin: 'Enter your 4-digit PIN',
  checkingPin: 'Checking…',
  wrongPin: 'Wrong PIN. Try again.',
  close: 'Close',
  backspace: 'Delete last digit',
  waiterSignOutWarning: "You'll be signed out automatically once your receipt prints.",
  noLongerWaiter:
    "This account is no longer a waiter, so it can't sign in from a tile.",
  removeThisTile: 'Remove this tile',

  // Remove
  removeTitle: (name) => `Remove ${name}?`,
  removeBody:
    'Only their tile on this till goes. Their account and their orders are untouched.',
  keep: 'Keep',
  remove: 'Remove',

  // Notices
  rejected: 'Your sign-in is no longer valid. Please sign in again.',
  printed: (orderNumber, name) =>
    `Order #${orderNumber} printed. ${name} signed out.`,

  // Errors
  required: 'Field is required',
  genericAuthError: 'Incorrect username or password',
};

/**
 * Dalabtire support, shown under the sign-in card.
 *
 * Two fields per number and they are not interchangeable:
 *
 *   display  what a person reads off the screen and taps into their own phone
 *   dial     what wa.me wants — country code straight into the subscriber
 *            number, no plus, no spaces, no leading zero
 *
 * The order is the order they appear in, and the first one is the one to try
 * first. Changing a number later is one line here and nowhere else.
 */
export const SUPPORT_CONTACTS = [
  { id: 'primary', display: '+252 61 575 3832', dial: '252615753832' },
  { id: 'second', display: '+252 61 654 9198', dial: '252616549198' },
];

/** The WhatsApp chat for one number. */
export function whatsappLink(contact) {
  return `https://wa.me/${contact.dial}`;
}

/**
 * Why an account was refused a tile. The role comes from the server's reply,
 * never from anything typed on this screen.
 */
export function notAWaiterMessage(role) {
  const named = {
    manager: 'a manager',
    cashier: 'a cashier',
    accountant: 'an accountant',
    'superadmin-superadmin': 'a super admin',
  }[role];
  return {
    title: `That account is ${named || 'not a waiter'}.`,
    body:
      'Only waiters get a tile here. Managers, cashiers and accountants sign in with their username and password on the left.',
  };
}
